module.exports = __webpack_public_path__ + "media/durango/dgo_gobierno-624460a9.png";